require('./components/summary-ng-hil-component/summary-ng-hil-component.ts');
require('./datasources/appt_summaries_datasource.ts');
require('./datasources/notes_datasource.ts');
require('./datasources/progress_reports_datasource.ts');
require('./commands/load_all_reports_command.ts');
require('./commands/load_appt_summaries_command.ts');
require('./commands/load_notes_command.ts');
require('./commands/load_progress_reports_command.ts');
require('./queries/reports_priority_feed_query.ts');
require('./routes.ts');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-reports/src/core.ts